import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent, searchBarEvent } from "@/lib/mixpanels/mixpanel";
import { useEffect } from "react";
import { Subjects } from "src/api/product";
import { defaultSearchType } from "src/api/search";
import useSearchDialogStore from "../store/searchDialog.store";
import { useRecommendSearchTerms } from "./useRecommendSearchTerms";
import { useSearchNavigation } from "./useSearchNavigation";
/**
 * GNB 검색 다이얼로그 훅
 * Zustand 스토어 + 추천 검색어 + 네비게이션 통합
 */ export const useSearchDialog = ()=>{
    const { user  } = useAuthStore();
    const userMainSubject = (user === null || user === void 0 ? void 0 : user.mainSubject) || Subjects.EN;
    // Zustand 스토어
    const { isOpen , searchTerm , selectedSubject: subject , open , close , setSearchTerm , clearSearchTerm , setSubject  } = useSearchDialogStore();
    // 추천 검색어
    const { recommendSearchTermList: recommendList  } = useRecommendSearchTerms(subject);
    // 네비게이션
    const { isSearchPage , currentUrlSubject , navigateToSearch , keyword  } = useSearchNavigation();
    // 다이얼로그 열기 (mixpanel 트래킹 포함)
    // 검색어/과목의 URL 복원은 아래 동기화 effect가 담당한다
    const handleOpen = ()=>{
        open();
        mixpanelEvent("Search Modal Clicked", {
            Subject: subject,
            Type: "Market",
            "Placeholder Text": recommendList === null || recommendList === void 0 ? void 0 : recommendList.placeHolder
        });
        mixpanelEvent("GNB Button Clicked", {
            position: "market",
            "button type": "search bar",
            "button name": "검색창"
        });
    };
    // 추천 검색어 클릭 (네비게이션 + 닫기)
    const onRecommendSelect = (searchKeyword)=>{
        navigateToSearch(searchKeyword, subject);
        close();
    };
    // 검색 제출 (트래킹 + 네비게이션 + 닫기)
    const submit = ()=>{
        searchBarEvent({
            keyword: searchTerm,
            search_type: defaultSearchType
        });
        navigateToSearch(searchTerm, subject);
        close();
    };
    // 아래 동기화 effect들은 트리거가 서로 다르므로 합치지 않는다.
    // 합치면 userMainSubject(= /me 응답 후 뒤늦게 확정)가 deps에 섞여,
    // 응답이 도착한 순간 사용자가 입력 중인 검색어를 URL 값으로 덮어쓴다.
    // 검색 페이지: URL의 q/subject를 스토어로 복원
    // 이후의 입력/삭제는 스토어가 보존한다 (deps가 URL 값이므로 타이핑 중에는 실행되지 않음)
    useEffect(()=>{
        if (!isSearchPage) return;
        setSearchTerm(typeof keyword === "string" ? keyword : "");
        if (currentUrlSubject) {
            setSubject(currentUrlSubject);
        }
    }, [
        isSearchPage,
        keyword,
        currentUrlSubject,
        setSearchTerm,
        setSubject
    ]);
    // 검색 페이지를 벗어나면 검색어를 비운다
    useEffect(()=>{
        if (isSearchPage) return;
        clearSearchTerm();
    }, [
        isSearchPage,
        clearSearchTerm
    ]);
    // 사용자 기본 과목 반영 (검색 페이지는 URL의 subject가 우선)
    useEffect(()=>{
        if (isSearchPage) return;
        setSubject(userMainSubject);
    }, [
        isSearchPage,
        userMainSubject,
        setSubject
    ]);
    return {
        // 다이얼로그
        isOpen,
        open: handleOpen,
        close,
        // 검색어
        searchTerm,
        setSearchTerm,
        clearSearchTerm,
        submit,
        // 과목
        subject,
        setSubject,
        // 추천 검색어
        recommendList,
        onRecommendSelect
    };
};
